/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rowstudentsonlyhint3Inputs */

const en_rowstudentsonlyhint3 = /** @type {(inputs: Rowstudentsonlyhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The door checks the student ID.`)
};

const de_rowstudentsonlyhint3 = /** @type {(inputs: Rowstudentsonlyhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Eingang wird der Ausweis geprüft.`)
};

/**
* | output |
* | --- |
* | "The door checks the student ID." |
*
* @param {Rowstudentsonlyhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rowstudentsonlyhint3 = /** @type {((inputs?: Rowstudentsonlyhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rowstudentsonlyhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rowstudentsonlyhint3(inputs)
	return de_rowstudentsonlyhint3(inputs)
});
export { rowstudentsonlyhint3 as "rowStudentsOnlyHint" }